import { useFormik } from "formik";
import WorkingHours from "../../../component/branches/WorkingHours";
import * as Yup from "yup";
import AddressDetails from "../../../component/branches/AddressDetails";
import UploadDoucments from "../../../component/branches/UploadDoucments";
import BasicDetails from "../../../component/branches/BasicDetails";
import AdminDetails from "../../../component/branches/AdminDetails";
import { _vendorAdminRoutes } from "../../../utils/appRouter";
import { apiUrl } from "../../../utils/endPoints/apiUrl";
import { _toastVariants, FILE_UPLOAD_DIR } from "../../../utils/Constant";
import { apiRequest } from "../../../utils/config/apiRequest";
import { showMessage } from "../../../utils/toast/globalToast";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchShopList } from "../../../store/slices/shopSlice";
import { useNavigate, useParams } from "react-router-dom";
import CustomModal from "../../../component/comman/CustomModal";
import ServiceListing from "../../../component/branches/services/ServiceListing";
import { uploadFile } from "../../../utils/helper/appHelpers";
// import ServiceListing from "../../../component/branches/services/ServiceListing";
import { useMovable } from "../../../context/MovableContext";
import AddPrintPrice from "../../../component/branches/print-price/PrintPrice";


const MODAL = {
  VIEW_SERVICE: 'VIEW_SERVICE',
  PRINT_PRICE: 'PRINT_PRICE'
}

const AddEditBranches = () => {

  const params = useParams();
  const shopId = params.shopId;

  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [shopDetail, setShopDetail] = useState({});

  const [modal, setModal] = useState({ name: '', data: null });
  
  const { SetShopId, SetLocationEnable, SetUserLocation, locationEnable,  } = useMovable();

  // Helpers
  const handleOpenModal = (name, data) => setModal({ ...modal, name, data });
  const handleCloseModal = () => setModal({ ...modal, name: '' });

  const initialValues = {
    branchName: "",
    thumbnail: "",
    lowestPrice: '',
    // services: [],
    // slot: "",
    statusupdate: "ACTIVE",
    address: {
      state: '',
      country: '',
      city: '',
      pincode: '',
      latitude: 0,
      longitude: 0,
      addressLine1: "",
      street: '',
      type: 'Home'
    },
    documents: [
      {
        name: "",
        attachments: [],
        expiryDate: ""
      }
    ],
    staffId: "",
    workingHours: [{
      day: '',
      startTime: null,
      endTime: null,
      isDayEnable: false
    }],
    dialCode: '',
    locationEnable: locationEnable, 
  };
  const validationSchema = Yup.object().shape({
    branchName: Yup.string().required("Branch Name is required"),
    // services: Yup.array().min(1, "Select at least one service").required("Services are required"),
    // slot: Yup.string().required("Slot is required"),
    statusupdate: Yup.string().required("Status update is required"),
    address: Yup.object().shape({
      state: Yup.string().required("Province is required"),
      country: Yup.string().required("Country is required"),
      city: Yup.string().required("City is required"),
      street: Yup.string().required("City is required"),
      pincode: Yup.string().required("Pincode is required"),
      addressLine1: Yup.string().required("Address is required")
    }),
    // admin: Yup.object().shape({
    //   // name: Yup.string().required("Name is required"),
    //   email: Yup.string().required("Email is required"),
    //   mobile: Yup.string().required("Mobile is required"),
    //   username: Yup.string().required("Username is required")
    // }),
    documents: Yup.array()
      .min(1, "At least one Branch document is required")
      .required("Branch documents are required")
      .test(
        "all-branch-document-fields-required",
        "All branch document fields are required",
        function (value) {
          if (!value || value.length === 0) return false;

          return value.every(
            (doc) =>
              doc.name &&
              doc.name.trim() !== "" &&
              doc.expiryDate &&
              doc.expiryDate.trim() !== "" &&
              Array.isArray(doc.attachments) &&
              doc.attachments.length > 0
          );
        }
      ),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setIsLoading(true);
        // ✅ Upload registration documents
        const uploadedDocs = await Promise.all(
          values.documents.map(async (doc) => {
            const uploadedFiles = await Promise.all(
              (doc.attachments || []).map(async (file) => await uploadFile(file, FILE_UPLOAD_DIR.STAFF))
            );
            return {
              ...doc,
              attachments: uploadedFiles,
            };
          })
        );
        const payload = {
          ...values,
          _id: shopDetail?._id,
          name: values.branchName,
          thumbnail: values.thumbnail,
          documents: uploadedDocs,
          status: values?.statusupdate
        };

        delete payload.statusupdate;

        // URL for Images
        if (typeof values.thumbnail !== 'string') {
          const formData = new FormData()
          formData.append('file', values.thumbnail);

          let { data, status } = await apiRequest({
            method: "POST",
            endUrl: apiUrl.uploadFile(FILE_UPLOAD_DIR.SHOP),
            body: formData,
            headerType: 'form'
          });

          if (status) {
            payload.thumbnail = data?.shortUrl
          }
        }

        const { status, message } = await apiRequest({
          endUrl: apiUrl.branch.addBranch,
          method: shopDetail?._id ? 'PUT' : 'POST',
          params: shopDetail?._id ? { shopId: shopDetail?._id } : '',
          body: payload,
          showMsg: true
        });
        if (status) {
          dispatch(fetchShopList());
          navigate(_vendorAdminRoutes.branches)
        }
      } catch (error) {
        showMessage({ variant: _toastVariants.Error, message: error.message });
      } finally {
        setSubmitting(false);
        setIsLoading(false);
      }
    },
  });

  const getShopDetailById = async () => {
    try {
      const { data, status } = await apiRequest({
        endUrl: apiUrl.branch.shopDetail,
        params: { shopId }
      })
      if (status) {
        setShopDetail(data)
      }
    } catch (error) {
    }
  }


  useEffect(() => {
    getShopDetailById();
  }, [shopId]);

  const { values, handleSubmit, setValues, errors } = formik;
  useEffect(() => {
    if (shopDetail._id) {
      setValues({
        shopId : shopDetail._id,
        branchName: shopDetail?.name || '',
        thumbnail: shopDetail?.thumbnail || '',
        lowestPrice: shopDetail?.lowestPrice || 0,
        statusupdate: shopDetail?.status || 'ACTIVE',
        address: shopDetail?.address || {},
        shopType:shopDetail?.shopType,
        documents: shopDetail?.documents.length ? shopDetail?.documents?.map((item) => ({
          name: item?.name || "",
          attachments: item?.attachments || [],
          expiryDate: item?.expiryDate || ""
        })) : values.documents,
        // admin: {
        //   username: shopDetail.userId.userName || '',
        //   dialCode: shopDetail.userId.dialCode || '',
        //   mobile: shopDetail.userId.mobileNo || '',
        //   email: shopDetail.userId.email || '',
        // },
        staffId: shopDetail?.userId?._id || '',
        workingHours: shopDetail.workingHours || values.workingHours
      })
    }
  }, [shopDetail])

  function getLocation(callback) {
  if (!navigator.geolocation) {
  }

}

  return (
    <section className="content mb-5">
      <div className="container-fluid" >
        <div className="row titlepad publsih-sticky">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
            <div className="row">
              <div className="col-sm-7">
                <h4>Branch Details</h4>
                <p className="page-sub-head">Add/Edit Branch</p>
              </div>
              <div className="col-md-5 text-sm-right mt-2" >
                <button
                  onClick={handleSubmit}
                  className="btn-md px-3 py-2 btn-primary"
                >
                  <i className="fa-regular fa-square-check" aria-hidden="true"></i> {!isLoading ? "Publish" : "Publishing..."}
                </button>
                <button
                  className="btn-md px-3 py-2 btn-primary"
                  disabled={!shopId}
                  onClick={() => handleOpenModal(MODAL.VIEW_SERVICE)}>Services
                </button>

                 {/* <button
                  className="btn-md px-3 py-2 btn-primary"
                  disabled={!shopId}
                  onClick={() => handleOpenModal(MODAL.PRINT_PRICE)}>Print Price
                </button> */}

                <a
                  href={_vendorAdminRoutes.branches}
                  className="btn-md px-3 py-2 btn-secondary"
                >
                  <i className="fa fa-chevron-circle-left"></i> Cancel
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <BasicDetails 
            formikProp={{
              ...formik,
              locationEnable,
          onLocationToggle: (checked) => {
          console.log("TOGGLE:", checked);

          SetLocationEnable(checked);
          SetShopId(shopId)

          if (checked) {
            navigator.geolocation.getCurrentPosition(
              (pos) => {
                const location = `${pos.coords.latitude},${pos.coords.longitude}`;
                console.log("FETCHED LOCATION:", location);
                SetUserLocation(location);
              },
              (err) => console.log("ERROR:", err)
            );
          }}
        }} 
          />

          <AddressDetails formikProp={formik} />
          <div className="col-md-8">
            <div className="tabData">
              <div className="pb-4">
                <div className="row">
                  <UploadDoucments formikProp={formik} />
                  <WorkingHours formikProp={formik} />
                </div>
              </div>
            </div>
          </div>
          <AdminDetails formikProp={formik} />
        </div>
      </div>
      {/* Add service */}
      <CustomModal width={60} open={modal.name === MODAL.VIEW_SERVICE} title={'Services'} onClose={handleCloseModal}>
        <ServiceListing shopId={shopId} userId={values?.staffId} onClose={handleCloseModal} />
      </CustomModal>

        {/* Print Price */}
        {/* <CustomModal width={60} open={modal.name === MODAL.PRINT_PRICE} title={'Printing Prices'} onClose={handleCloseModal}>
            <AddPrintPrice shopId={shopId} userId={values?.shopKeeper?._id} onClose={handleCloseModal} />
        </CustomModal> */}
    </section>
  );
};

export default AddEditBranches;